import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: [String, Boolean, Array]
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: [String, Boolean, Array]
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      value: this.modelProps,
      options: this.config.datasource.options ? this.config.datasource.options : []
    }
  },
  mounted () {
    if(!this.modelProps && !this.R.isNil(this.config.defaultValue)) {
      this.value = this.config.defaultValue
    }
  },
  watch: {
    value (newValue, oldValue) {
      if(this.config.chooseOne && this.config.typeGroup !== 'radio' && newValue.length > 1) {
        this.value = this._.difference(newValue, oldValue)
      }
      this.$emit('input', this.value)
    },
    modelProps: {
      handler: function(newValue) {
        this.value = newValue
      }
    },
    'config.datasource.options': {
      handler: function(newValue) {
        this.options = newValue
      }
    }
  },
  computed: {
    validationRules () {
      return this.expressionResolver(this.config.validation)
    }
  },
  methods: {
    onBlur () {}
  }
}
